module.exports = __webpack_public_path__ + "img/go-past-btn1.6f986d0d.png";